import { layoutModel } from 'layout/main-layout';
import { Role } from 'models/user';
import { useOutletContext } from 'react-router-dom';

interface PrivateComponentProps {
  allowedRoles: Role[];
  children: JSX.Element;
}

const PrivateComponent = ({ children, allowedRoles }: PrivateComponentProps) => {
  const currentRole = useOutletContext<layoutModel.OutletContext>().role;

  if (!allowedRoles.includes(currentRole)) return <></>;

  return <>{children}</>;
};

export default PrivateComponent;
